"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("./styles");
var _dompurify = _interopRequireDefault(require("dompurify"));
require("quill/dist/quill.snow.css");
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** @jsxImportSource @emotion/react */

const Html = ({
  className,
  dark,
  externalLinks,
  removeMargins,
  secondary,
  size,
  text,
  sanitize = true,
  sanitizeOptions,
  whiteSpace,
  allowVideo = false,
  disableFullscreenVideo = false
}) => {
  let _sanitizeOptions = allowVideo ? {
    ADD_TAGS: ['iframe', 'video'],
    ADD_ATTR: disableFullscreenVideo ? ['frameborder', 'scrolling'] : ['allow', 'allowfullscreen', 'frameborder', 'scrolling'],
    ...sanitizeOptions
  } : {
    ...sanitizeOptions
  };
  let safeHtml = sanitize ? _dompurify.default.sanitize(text, _sanitizeOptions) : text;
  safeHtml = safeHtml.replace(/&nbsp;/g, ' ');
  const classes = `snorre-html ${className || ''}`;
  return (0, _jsxRuntime.jsx)("div", {
    className: classes,
    css: theme => [_styles.styles.default(theme), secondary && _styles.styles.secondary(theme), dark && _styles.styles.dark(theme), size && _styles.styles.size(size), _styles.styles.whiteSpace(whiteSpace ? whiteSpace : 'pre-wrap'), removeMargins && _styles.styles.removeMargins],
    dangerouslySetInnerHTML: {
      __html: externalLinks ? safeHtml.replace(/href/g, "target='_blank' href") : safeHtml
    }
  });
};
var _default = exports.default = Html;